/* eslint-disable max-len, no-trailing-spaces, eol-last, indent, comma-dangle, comma-spacing, prefer-const, spaced-comment, key-spacing, no-multi-spaces, semi, object-property-newline, quotes, react/display-name, id-length, operator-linebreak, react/prop-types, no-shadow, no-undef, max-lines-per-function, space-infix-ops, no-unused-vars, init-declarations */
import { serviceName } from '../resources/serviceConstants';
import { DASHBOARD, COLUMN_CUSTOMIZATION, GET_COLUMN_DATA,
  DEAL_TRANSITION_FORM, DEAL_TRANSITION_DETAILS, DEAL_SAVE_FOR_LATER, GET_TABULAR_VIEW ,MANUAL_ASSIGNMENT, UPLOAD_FILES, REMOVE_FILES} from '../resources/endPoint';

export const getDashboardDetails = () => {
  return {
    url: DASHBOARD,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const getCount = (startDate, endDate, userId) => {
  let url = `${DASHBOARD}?countValueBoth=count&userId=${userId}`;

  if (startDate && endDate) {
    url += `&startDate=${startDate}&endDate=${endDate}`;
  }

  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const getValue = (startDate, endDate, userId) => {
  let url = `${DASHBOARD}?countValueBoth=value&userId=${userId}`;

  if (startDate && endDate) {
    url += `&startDate=${startDate}&endDate=${endDate}`;
  }

  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const columnCustomizationList = (userId, customParameter) => {
  const data = {
    user_id: userId,
    custom_parameters: customParameter,
  };
  return {
    url: COLUMN_CUSTOMIZATION,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const parameterList = (userId) => {
  return {
    url: GET_COLUMN_DATA + '?user_id=' + userId,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const tabularViewList = (userId, page, limit, search, sort, sortOrder) => {
  let url = `${GET_TABULAR_VIEW}?userId=${userId}&page=${page}&limit=${limit}`;

  if (search) {
    url += `&search=${search}`;
  }

  if (sort) {
    url += `&sort=${sort}`;
  }

  if (sortOrder) {
    url += `&order=${sortOrder}`;
  }
  return {

    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: [],
    service: serviceName.DEAL_TRANSITION_MS,
  };
};


export const getFormValue = (dealId) => {
  return {
    url: DEAL_TRANSITION_FORM + '?deal_id=' + dealId,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const setFormValue = (payload, isFetch = false) => {
  return {
    url: DEAL_TRANSITION_DETAILS,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: isFetch ? { fetchData: true, deal_id: payload.deal_id } : payload,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const setSaveForLater = (data) => {
  return {
    url: DEAL_SAVE_FOR_LATER,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const assignDealToEmployee = (dealId, employeeId, assigneeName) => {
  return {
    url: `${MANUAL_ASSIGNMENT}`,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
    payload: {
      deal_id: dealId,
      employee_id: employeeId,
      assignee_name: assigneeName,
    },
  };
};

export const saveUploadedFiles = (data) => {
  return {
    url: UPLOAD_FILES,
    method: 'post',
    headers: { 'content-type': 'multipart/form-data' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const deleteUploadedFiles = (data) => {
  return {
    url: REMOVE_FILES,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

